// src/redux/services/jt808Api.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BACKEND_URL || "http://localhost:7600/api",
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth?.token || localStorage.getItem("token");
    if (token) headers.set("x-auth-token", token);
    return headers;
  },
});

export const jt808Api = createApi({
  reducerPath: "jt808Api",
  baseQuery,
  tagTypes: ["JT808Media"],
  endpoints: (builder) => ({
    // ✅ Send 0x8801 to take photo
    takePhoto: builder.mutation({
      query: ({ cameraId, channelId = 1, photos = 1, interval = 0, saveSign = 0 }) => ({
        url: `/jt808/camera/${cameraId}/take-photo`,
        method: "POST",
        body: { channelId, photos, interval, saveSign },
      }),
    }),

    // ✅ List last media (optionally filter by deviceId/cameraId/terminalId/status)
    listMedia: builder.query({
      query: (params = {}) => ({
        url: `/jt808/media`,
        params,
      }),
      providesTags: (result, error, params) => [{ type: "JT808Media", id: params?.cameraId || "LIST" }],
      transformResponse: (res) => res?.data || [],
    }),

    // ✅ Download URL helper (frontend just open this URL)
    getDownloadUrl: builder.query({
      query: (id) => `/jt808/media/${id}/download`,
    }),
  }),
});

export const {
  useTakePhotoMutation,
  useLazyListMediaQuery,
  useListMediaQuery,
} = jt808Api;
